import { DAYS_OF_WEEK } from '../data';
import { cn } from '@/lib/utils';

export function DaysPicker({ selectedDays, onToggle }) {
  return (
    <div>
      <h2 className="text-base font-bold text-slate-900 sm:text-lg">
        Which days work for you?
      </h2>
      <p className="mt-1 text-sm text-slate-600">
        Pick all the days you could attend a class.
      </p>
      <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-6">
        {DAYS_OF_WEEK.map((day) => {
          const isActive = selectedDays.includes(day.value);
          return (
            <button
              key={day.value}
              type="button"
              onClick={() => onToggle(day.value)}
              aria-pressed={isActive}
              aria-label={day.fullLabel}
              className={cn(
                'flex h-14 cursor-pointer items-center justify-center rounded-xl border-2 text-base font-bold uppercase tracking-wide transition-all',
                isActive
                  ? 'border-brand-600 bg-brand-600 text-white shadow-md ring-2 ring-brand-200'
                  : 'border-slate-200 bg-white text-slate-800 hover:border-brand-300 hover:bg-slate-50'
              )}
            >
              {day.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}